<template>
  <div>
    <label class="block text-sm font-medium text-secondary-lighter">
      {{ label }}</label>
    <select
      :value="selected"
      :disabled="disabled"
      :name="htmlName"
      class="mt-1 text-input-standard rounded-md border-secondary-light py-2 pl-3 pr-10 text-base focus:border-lilac focus:outline-hidden focus:ring-lilac sm:text-sm"
      @input="$emit('update:selected', $event.target.value)"
    >
      <option v-if="showFirstOption" disabled value="">
        {{ firstOption }}
      </option>
      <option v-for="o of options" :key="o">
        {{ o }}
      </option>
    </select>
  </div>
</template>

<script setup>
defineEmits(['update:selected'])

defineProps({
  options: {
    type: Array,
    required: true
  },
  selected: {
    type: String,
    required: true
  },
  htmlName: {
    type: String,
    default: ''
  },
  label: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  firstOption: {
    type: String,
    default: 'Bitte auswählen'
  },
  showFirstOption: {
    type: Boolean,
    default: true
  }
})
</script>

<style scoped>
select {
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
